// extracted by mini-css-extract-plugin
export default {"hero":"dEupvstT42cTFjn0pNRa","background":"xqjoCtatOVwKPn5i4byS"};